// extracted by mini-css-extract-plugin
export var bodySections = "_an-8";
export var gray = "_an-7";
export var green = "_an-4";
export var iconContainer = "_an-9";
export var iconWidgetContainer = "_an-1";
export var phoneIcon = "_an-2";
export var red = "_an-5";
export var statusDot = "_an-3";
export var widgetContainer = "_an-0";
export var yellow = "_an-6";